const steps = [
  {
    n: "01",
    title: "We scan the internet's blind spots",
    desc: "While you sleep, our AI crawls 35+ sources most tools never touch — from patent feeds to TikTok comment graveyards.",
  },
  {
    n: "02",
    title: "Trends are scored, ranked, and decoded",
    desc: "Velocity, search intent, monetization potential, and competition density. Every niche gets a profit score from 0–100.",
  },
  {
    n: "03",
    title: "You get the blueprint, not the homework",
    desc: "Open a trend, see the buyer, the price, the angle, the supplier or template, and the 7-day launch plan. Build today.",
  },
];

const HowItWorks = () => (
  <section className="py-32 border-y border-border bg-secondary/10">
    <div className="container">
      <div className="max-w-2xl mb-20">
        <div className="font-mono text-xs text-primary mb-4">// WORKFLOW</div>
        <h2 className="font-display text-4xl md:text-6xl font-bold leading-tight">
          From signal to <span className="text-gradient-primary">shipped product</span> in three steps.
        </h2>
      </div>
      <div className="grid md:grid-cols-3 gap-8">
        {steps.map((s) => (
          <div key={s.n} className="relative">
            <div className="font-display text-7xl font-bold text-primary/20">{s.n}</div>
            <h3 className="font-display text-2xl font-semibold mt-4 mb-3">{s.title}</h3>
            <p className="text-muted-foreground leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
